import apiClient from './apiClient';

/**
 * Event Participants API functions
 */
export const eventParticipantsApi = {
  /**
   * Get event participants data
   * @param eventId - The event ID
   * @param userId - Optional user ID for admin viewing as user
   */
  getEventParticipants: async (eventId: string, userId?: string) => {
    try {
      console.log('Fetching event participants from API...');
      const url = userId 
        ? `/api/v2/web/events/${eventId}/participants?user_id=${userId}`
        : `/api/v2/web/events/${eventId}/participants`;
      const response = await apiClient.get(url);
      console.log('Event participants API response data:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in getEventParticipants:', error);
      throw error;
    }
  },

  /**
   * Save user selection for event
   * @param eventId - The event ID
   * @param selectedUserIds - Array of selected user IDs
   * @param targetUserId - Optional user ID for admin saving on behalf of user
   */
  saveUserSelection: async (eventId: string, selectedUserIds: string[], targetUserId?: string) => {
    try {
      console.log('Saving user selection...');
      
      // Determine which user's selection to save
      let userId: string;
      if (targetUserId) {
        // Admin is saving for a specific user
        userId = targetUserId;
      } else {
        // Regular user is saving their own selection
        const userResponse = await apiClient.get('/api/v2/web/auth/me');
        userId = userResponse.data.User_ID;
      }

      // Use the selections endpoint as in the original Django implementation
      const response = await apiClient.post(
        `/api/v2/web/events/${eventId}/selections/user/${userId}`, 
        { selected_user_ids: selectedUserIds }
      );
      
      console.log('Save selection API response data:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error in saveUserSelection:', error);
      throw error;
    }
  }
};
